import React, {Component} from 'react';

import styled from 'styled-components';

import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import {faChevronLeft, faChevronRight} from '@fortawesome/fontawesome-free-solid';
import anime from 'animejs';
import Defaulf_Img from './vehicleimagenotavailable1.png';

class VariantCarouselSlidePicker extends Component {

    scrollContainerEl = React.createRef()

    scrollLeft() {
        const {options, value, onChange} = this.props;
        const index = options.findIndex(i=>i.id === value);
        if(index > 0) {
            onChange(options[index - 1].id);
        }
    }

    scrollRight() {
        const {options, value, onChange} = this.props;
        const index = options.findIndex(i=>i.id === value);
        if(index < options.length - 1) {
            onChange(options[index + 1].id);
        }
    }
    
    render() {

        function imageExists(image_url){

            var http = new XMLHttpRequest();
        
            http.open('HEAD', image_url, false);
            http.send();
        
            return http.status != 404;
        
        }

        const {className} = this.props;

        const {options, value, valueDescription, onChange} = this.props;

        let prefix = '';
        return <div className={className}>
            <div className={'carousel-slide-picker__carousel'}>
                {
                    options.length > 1 && <a href="javascript:void(0)"
                                             onClick={this.scrollLeft.bind(this)}
                                             className="carousel__arrow carousel__arrow--left">
                        <FontAwesomeIcon icon={faChevronLeft} size={'1x'}/>
                    </a>
                }

                <div className={'carousel-slide-picker__option-container parent'} ref={this.scrollContainerEl}>                    
                    {
                        options.map((item, index) => {
                            var url = `${item.src}`;
                            var url_array = url.split("/");
                            var imgName = url_array[url_array.length-1]; 
                            let src;  
                            if (imgName == 'vehicleimagenotavailable1.PNG'){
                                src = Defaulf_Img              
                            } else {
                                src = item.src
                            } 
                            return <div>
                                {
                                   
                                    item.id === value && 
                                    <div key={index}
                                        onClick={e => onChange(item.id)}>
                                        <div className="modelName">
                                            {/* <div className="itemBox">{item.id}</div> */}
                                            {/* <div className="">{item.carModelName}</div> */}
                                        </div>
                                    </div>
                                }
                                
                            </div>
                        })
                    }
                </div>

                {
                    options.length > 1 && <a href="javascript:void(0)"
                                             onClick={this.scrollRight.bind(this)}
                                             className="carousel__arrow carousel__arrow--right">
                        <FontAwesomeIcon icon={faChevronRight} size={'1x'}/>
                    </a>
                }


            </div>

            <p className={'carousel-slide-picker__selected'}>
                {valueDescription}
            </p>


        </div>
    }
}

export default styled(VariantCarouselSlidePicker)`
.modelName{
    font-size:24px;
}
.parent {
  width: 20%;
  float: left;
}

.container {
  display: block;
  width: 100%;
  height: auto;
  position: relative;
  overflow: hidden;
  padding: 1% 0 0 0;
   /* 34.37% = 100 / (w / h) = 100 / (640 / 220) */
}

.container img {
  display: block;
  max-width: 100%;
  max-height: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
  & {
    max-width: 450px;
    margin: 0 auto;
    padding: 0px 12px;
    text-align: center;
    // margin-left: 2.5%;
    @media (max-width: 1000px){
        margin-left: 0;
    }
  }
  .carousel__arrow {
    color: #B2B2B2;
  }
  .carousel__arrow:hover {
    color: rgba(25,25,25,0.3);
  }
  .svg-inline--fa.fa-w-10 {
    width: 0.555em;
  }

  .carousel-slide-picker__carousel {
    display: flex;
    flex-direction: row;
    position: relative;
    padding-top: 13px;
    > a {
      display: block;
      text-align: center;
    }
  }
  .carousel__arrow--left {
      position: absolute;
      left: -42%;
      top: 50px;
  }
  .carousel__arrow--right {
      position: absolute;
      right: -42%;
      top: 50px;
  }

  @media (max-width: 1199px) {
      .carousel__arrow--left {
        left: 0 !important;
    }
    .carousel__arrow--right {
        right: 0% !important;
    }
    .carousel-slide-picker__option-container {
      margin-left: 5% !important;
      margin-right: 5% !important;
    }
  }
  .carousel-slide-picker__option-container {
      flex: 1;

      display:-ms-flexbox;
      -ms-flex-pack:center;
      -ms-flex-align:center;
      display:-moz-box;
      -moz-box-pack:center;
      -moz-box-align:center;
      display:-webkit-box;
      -webkit-box-pack:center;
      -webkit-box-align:center;
      display:box;
      box-pack:center;
      box-align:center;

      width: 100%;
      margin-left: -25%;
      margin-right: -25%;
      & {
            -ms-overflow-style: none;  // IE 10+
            overflow: -moz-scrollbars-none;  // Firefox
        }
      &::-webkit-scrollbar { 
            display: none;  // Safari and Chrome
        }
  }

  
  .carousel-slide-picker__option-item {
    display: inline-block;
    width: 20%;

    &:not(:last-child) {
      margin-right: 5%;
    }
    
    > img {
      width: 72px;
      height: 72px;
      padding: 0;
    }
  }
  
  .carousel-slide-picker__option-item_active .itemActive{
    /* border-bottom: 6px solid #0190fe; */
    width: 90px;
    height: 92px;
  }

  .carousel-slide-picker__option-item_active{
    padding: 0 0 0 0;
    border-bottom: 6px solid #0190fe;
    margin-bottom: -6px;
  }
  
  .carousel-slide-picker__selected {
    text-align: center;
    margin-top: 12px;
    color: rgba(25,25,25,0.5);
    margin-bottom: 0;
    padding-bottom: 15px;
    @media (max-width: 1000px){
        margin-bottom: 1em;
        border-bottom: 0px;
        padding-bottom: 0px;
    }
  }

  .flex-row div {
      font-size: 11.5px;
  }
  
  .itemBox {
      border: 1px solid #f3f3f3;
      margin-bottom: 3px;
      padding-top: 3px;
      white-space: pre-line;
      word-break: break-all;
  }

`


// WEBPACK FOOTER //
// ./src/components/configurator/VariantCarouselSlidePicker.js